/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import styles from '../../../style';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  IconButton
} from '@material-ui/core';
import {
  CheckOutlined,
  ClearOutlined,
  Edit,
  DeleteOutline
} from '@material-ui/icons';
import { connect } from 'react-redux';
import {
  saveAdditionalItems,
  updateAdditionalItems,
  deleteAdditionalItems,
  getPatientMedicalHistory
} from 'services/soap/action';

const AdditionalItems = props => {
  const { classes, patientId, ptMedicalHistory, getPatientMedicalHistory } = props;

  const initialUserState = {
    id: 0,
    description: ''
  };
  const [values, setValues] = useState(initialUserState);
  const [editvalues, setEditValues] = useState(initialUserState);
  const [AI, setAI] = useState(null);
  const [isEdit, setIsEdit] = useState(false);

  useEffect(() => {
    if (ptMedicalHistory?.additionalItems && ptMedicalHistory?.additionalItems?.length > 0) {
      setAI(ptMedicalHistory?.additionalItems);
    }
  }, [ptMedicalHistory]);

  const handleFieldChange = (field, value) => {
    setValues({ ...values, [field]: value });
  };

  const handleEditFieldChange = (field, value) => {
    setEditValues({ ...editvalues, [field]: value });
  };

  const handleSaveAdditionalItems = async () => {
    if (values.description) {
      const res = await props.saveAdditionalItems(patientId, values);
      if (res.status) {
        setValues(initialUserState);
        getPatientMedicalHistory(patientId);
      }
    }
  };

  const handleUpdateAdditionalItems = async idx => {
    if (editvalues.description) {
      const res = await props.updateAdditionalItems(patientId, editvalues);
      if (res.status) {
        setIsEdit(false);
        getPatientMedicalHistory(patientId);
      }
    }
  };

  const handleDeleteAdditionalItems = async id => {
    const res = await props.deleteAdditionalItems(patientId, id);
    if (res.status) {
      setValues(initialUserState);
      getPatientMedicalHistory(patientId);
    }
  };

  const handleEditAdditionalItems = async (data, index) => {
    setIsEdit(true);
    if (data) {
      setEditValues({
        id: data.id,
        description: data.description,
        editIndex: index
      });
    }
  };

  const clearAdditionalItems = () => {
    setIsEdit(false);
    setValues(initialUserState);
  };

  return (
    <div className={classes.templateWrap}>
      <div className={classes.templateBody} style={{ borderTop: 'default' }}>
        <PerfectScrollbar>
          <div style={{ maxHeight: 'calc(100vh - 298px)' }}>
            <Table className={classes.templateTable}>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <TextField
                      className={classes.textBox}
                      id="outlined-basic"
                      InputProps={{
                        classes: {
                          notchedOutline: classes.notchedOutline
                        }
                      }}
                      onChange={event =>
                        handleFieldChange('description', event.target.value)
                      }
                      placeholder="Input description"
                      value={values.description}
                      variant="outlined"
                    />
                  </TableCell>

                  <TableCell
                    width="10%"
                    align="center"
                    style={{ whiteSpace: 'nowrap' }}>
                    <IconButton
                      // disabled={values.description || values.reaction}
                      onClick={() => handleSaveAdditionalItems()}
                      size="small"
                      style={{ color: '#03A484' }}>
                      <CheckOutlined />
                    </IconButton>
                    <IconButton
                      onClick={() => clearAdditionalItems()}
                      size="small">
                      <ClearOutlined style={{ color: '#DE5555' }} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {AI &&
                  AI.length > 0 &&
                  AI.map((item, idx) => {
                    return (
                      <TableRow>
                        {isEdit && idx === editvalues.editIndex ? (
                          <>
                            <TableCell>
                              <TextField
                                className={classes.textBox}
                                id="outlined-basic"
                                InputProps={{
                                  classes: {
                                    notchedOutline: classes.notchedOutline
                                  }
                                }}
                                onChange={event =>
                                  handleEditFieldChange(
                                    'description',
                                    event.target.value
                                  )
                                }
                                placeholder="Input description"
                                value={editvalues.description}
                                variant="outlined"
                              />
                            </TableCell>
                          </>
                        ) : (
                          <>
                            <TableCell>{item.description}</TableCell>
                          </>
                        )}
                        <TableCell align="center" width={72}>
                          {isEdit && idx === editvalues.editIndex ? (
                            <>
                              <IconButton
                                // disabled={values.description || values.reaction}
                                onClick={() => handleUpdateAdditionalItems(idx)}
                                size="small"
                                style={{ color: '#03A484' }}>
                                <CheckOutlined />
                              </IconButton>
                              <IconButton
                                onClick={() => clearAdditionalItems()}
                                size="small">
                                <ClearOutlined style={{ color: '#DE5555' }} />
                              </IconButton>
                            </>
                          ) : (
                            <>
                              <IconButton
                                onClick={() =>
                                  handleEditAdditionalItems(item, idx)
                                }
                                size="small">
                                <Edit color="primary" />
                              </IconButton>
                              <IconButton
                                onClick={() =>
                                  handleDeleteAdditionalItems(item.id)
                                }
                                size="small">
                                <DeleteOutline style={{ color: '#DE5555' }} />
                              </IconButton>
                            </>
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </div>
    </div>
  );
};
AdditionalItems.propTypes = {
  className: PropTypes.string
};
const mapDispatchToProps = {
  saveAdditionalItems,
  updateAdditionalItems,
  deleteAdditionalItems,
  getPatientMedicalHistory
};

const mapStateToProps = (state) => ({
  ptMedicalHistory: state.soap && state.soap.ptMedicalHistory,
});
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(styles)(AdditionalItems))
);
